import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { Waiting } from '../waiting/waiting';
import { RerunTask } from '../rerun-task/rerun-task';
import { UploadDocument } from '../upload-document/upload-document';
import { DocumentService } from '../../_services/document.service';
import { DocumentTypeEnum } from '../../_enums/document-type.enum';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WorkProcessSelector } from '../work-process-selector/work-process-selector';
import { WorkProcessWithClient } from '../../_models/social-domain/workprocess-with-client.model';

@Component({
  selector: 'app-verify-action-plan',
  imports: [
    TranslateModule,
    MatButton,
    Waiting,
    RerunTask,
    UploadDocument,
    MatTooltipModule,
    WorkProcessSelector,
  ],
  templateUrl: './verify-action-plan.html',
  styleUrl: './verify-action-plan.scss',
})
export class VerifyActionPlan implements OnInit, OnChanges {
  @ViewChild('uploadDocument') uploadDocument!: UploadDocument;
  @Input() actionPlanVerdict: string | undefined;
  @Input() actionPlanVerdictError: boolean = false;
  @Input() isVerifyInProgress = false;
  @Input() isUploadInProgress = false;
  @Input() uploadDone = false;
  @Input() canUpload = false;

  @Input() preselectedWorkProcess: WorkProcessWithClient | null = null;
  @Output() uploadToSsd = new EventEmitter<void>();
  @Output() workProcessSelected = new EventEmitter<WorkProcessWithClient>();

  @Output() rerun = new EventEmitter<void>();

  public actionPlanExists = false;
  public DocumentTypeEnum = DocumentTypeEnum;

  private isVerificationUpToDate = false;

  get isVerifyDisabled(): boolean {
    return !this.actionPlanExists || this.isVerifyInProgress || this.isVerificationUpToDate;
  }

  private readonly documentService = inject(DocumentService);

  public ngOnInit(): void {
    this.subscribeToDocumentChanges();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['actionPlanVerdict']) {
      this.isVerificationUpToDate = this.actionPlanVerdict !== undefined;
    }
  }

  public verifyActionPlan(): void {
    this.documentService.setDocumentChanged(DocumentTypeEnum.ACTION_PLAN, false);
    this.documentService.setOptionalDocumentsChanged(false);
    this.rerun.emit();
  }

  private subscribeToDocumentChanges(): void {
    this.documentService.getDocument(DocumentTypeEnum.ACTION_PLAN).subscribe((file) => {
      this.actionPlanExists = !!file;
    });

    this.documentService.isDocumentChanged(DocumentTypeEnum.ACTION_PLAN).subscribe((changed) => {
      if (changed) {
        this.documentService.setDocumentChanged(DocumentTypeEnum.ACTION_PLAN, false);
        this.actionPlanVerdict = undefined;
        this.actionPlanVerdictError = false;
        this.isVerificationUpToDate = false;
      }
    });

    this.documentService.isOptionalDocumentsChanged().subscribe((changed) => {
      if (changed) {
        this.isVerificationUpToDate = false;
      }
    });
  }
}
